
<template>
  <BasicTable
    v-loading="loading"
    :config="config"
    :data="data"
  />

</template>

<script setup>
const props = defineProps({
  tabTimeValue: {
    default: []
  },
})

// const isDepositOptions = [
//   {
//     label: '是',
//     value: 0,
//   },
//   {
//     label: '否',
//     value: 1,
//   }
// ]

// const isTradeOptions = [
//   {
//     label: '是',
//     value: 0,
//   },
//   {
//     label: '否',
//     value: 1,
//   }
// ]

let loading = $ref(false)
let data = $ref([])
const getData = async () => {
  try {
    loading = true
    const body = {}
    if (!isEmpty(props.tabTimeValue)) {
      body.startTime = props.tabTimeValue[0]
      body.endTime = props.tabTimeValue[1]
    }
    const d = await dataApi.firstTrade(body)
    data = d
  } finally {
    loading = false
  }
}

// 表格配置
const config = $computed(() => {
  return [
    { label: 'uid', prop: 'uid', minWidth: 100 },
    { label: $t('trade.fee'), prop: 'fee', type: 'num' },
    { label: $t('public.tradeTime'), prop: 'date' },
  // { label: '首次交易', prop: 'date', type: 'time', width: 172, align: 'right' },
  ]
})

onBeforeMount(async () => {
  getData()
})

watch(() => props.tabTimeValue, () => {
  getData()
})
</script>

<style lang="scss">
</style>
